import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import CartList from '../components/CartList';
import BillingForm from '../components/billing-form/BillingForm';
import PurchaseSuccess from '../components/PurchaseSuccess';
import PurchaseError from '../components/PurchaseError';
import ItemList from '../components/donation-catalog/ItemList';
import DonationDedicationForm from '../components/DonationDedicationForm';
import { CURRENCIES } from '../constants/currencies';

class DonationView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			billingStage: false,
		}
	}

	handleClick = event => {
		event.preventDefault();
		const { cartItems, currency } = this.props.shopStore;
		cartItems.clear();		
		currency.set(CURRENCIES.usd);
	}

	/*componentDidUpdate() {
		console.log('XXXXX');
		window.scrollTo(0, 0);
	}*/	

	render() {			
		const { shopStore } = this.props;
		const cashsale = shopStore.cashsale.get();
		const purchaseError = shopStore.purchaseError.get();
		if (purchaseError) {
			return <PurchaseError message={purchaseError} />
	  	} else if (cashsale) {		
			if (typeof(window.ga) === 'function') {	  
				let productPayload = {
					'id': cashsale.lineitems[0].itemname,
					'name': cashsale.lineitems[0].itemname,
					'category': 'Giving',
					//'brand': 'Google',
					'variant': (shopStore.recurrenceFrequency.get() === 1 ? 'Recurring' : 'One time'),
					'price': cashsale.total.replace(',', ''),
					'quantity': 1					
				}
				let purchasePayload = {
					'id': cashsale.ordernumber,
					//'affiliation': 'Google Store - Online',
					'revenue': cashsale.total.replace(',', ''),
					'tax': 0,
					'shipping': 0,
					//'coupon': 'SUMMER2013'    // User added a coupon at checkout.					
				}
				
				window.ga('require', 'ec');

				window.ga('set', 'currencyCode', cashsale.currencysymbol);
				console.log('CCCCCCCCCC', cashsale.currencysymbol);

				window.ga('ec:addProduct', productPayload);
				
				// Transaction level information is provided via an actionFieldObject.
				window.ga('ec:setAction', 'purchase', purchasePayload);

				//console.log('XXXXX', productPayload, purchasePayload);
				
				window.ga('send', 'pageview');     // Send transaction data with initial pageview.				
			}			  	
			return (
				<PurchaseSuccess 
					orderNumber={cashsale.ordernumber} 
					total={cashsale.total} 
					isDonation={true}
					currencyCode={cashsale.currencysymbol}
				/>
			);
		} else if (!shopStore.cartItems.size) {
			return (
				<ItemList />
			);
		}		
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<a href="" onClick={this.handleClick}>
							&lt;&lt; Back to donation projects list
						</a>
					</div>
				</div>
				<hr />
				<br />
				<div className="row">
					<div className="col-lg-4 order-lg-2 mb-4">
						<CartList />
						{shopStore.recurrenceFrequency.get() === 1 &&
							<div className="alert alert-warning">
								Your credit card will be charged on a <strong>monthly</strong> basis.
							</div>
						}
						<DonationDedicationForm />
					</div>
					{shopStore.cartItems.size > 0 &&
						<div className="col-lg-8 order-lg-1">
							<BillingForm />					
						</div>									
					}
				</div>
			</div>
		);
	}

}

export default inject('shopStore')(observer(DonationView));




// WEBPACK FOOTER //
// ./src/views/DonationView.js